module.exports = __webpack_public_path__ + "img/profile.2135cb48.webp";